import React from 'react';
import classnames from 'classnames';
import classes from './arrow.scss';
const Arrow = props => {
  const {
    onClick,
    side
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, classes[`container-${side}`]),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.icon, classes[side], {
      [classes.disabled]: !onClick
    })
  }));
};
export default Arrow;